import routes from './routes';
import { SetRoutes } from 'components';

const BlankPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default BlankPages;
